import React, { Component } from "react";
import classnames from "classnames";

import { IMenuItem } from "../Menu/IMenuItem";
import { MenuButton } from "../MenuButton";
import * as styles from "./index.scss";

export interface IDeviceMenuViewerProps {
    mode: "observe" | "operate";
    showingFilters?: boolean;
    onToggleFilters?: () => void;
}

export class DeviceMenuViewer extends Component<IDeviceMenuViewerProps> {
    private isObserve = this.props.mode === "observe";
    private isOperate = this.props.mode === "operate";
    public render() {
        const { isObserve, isOperate } = this;

        const items: IMenuItem<string>[] = [...this.toggleFiltersItem(1)];

        if (items.length === 0) {
            return false;
        }

        return (
            <MenuButton
                items={items}
                header={isObserve}
                className={styles.menu}
                buttonClassName={classnames(
                    styles.button,
                    isOperate && styles.operate,
                )}
                bottom={isOperate}
                data-testid="device-menu-button"
            />
        );
    }

    private toggleFiltersItem(group?: number): IMenuItem<string>[] {
        return [
            {
                icon: "filter",
                value: `${this.props.showingFilters ? "Hide" : "Show"} filters`,
                onSelected: this.props.onToggleFilters,
                group,
            },
        ];
    }
}
